module.exports = __webpack_public_path__ + "svg/check-mark-green.5965586d55fd34703c3b9e26078349e1.svg";